/* SMS lightweight legacy-content loader plus WEB/CATALOG guards — main working draft. */
(() => {
  const smsPath = (window.location.pathname || '/').replace(/\/+$/, '') || '/';

  /* Keep Shopify's utility product-type route out of search results. */
  if (smsPath === '/collections/types') {
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement('meta');
      robots.setAttribute('name', 'robots');
      document.head.appendChild(robots);
    }
    robots.setAttribute('content', 'noindex,follow');
  }

  /* Pickup-only custom enclosure must not display a shipping-at-checkout notice. */
  if (document.querySelector('[data-sms-strict-configurator-root="enclosure"]')) {
    document.querySelectorAll('.product-form__price-info').forEach((node) => {
      if (/shipping\s+is\s+calculated/i.test(node.textContent || '')) node.remove();
    });
  }

  if (!document.querySelector('.sms-page-shell__body[data-sms-normalize="legacy-page"]')) return;
  const loader = document.currentScript || Array.from(document.scripts).find(s => (s.src || '').includes('sms-content-normalizer.js'));
  if (!loader) return;
  const coreSrc = loader.dataset.coreSrc;
  if (!coreSrc) return;
  const core = document.createElement('script');
  core.src = coreSrc;
  core.async = false;
  document.head.appendChild(core);
})();

/* Metricool website analytics tracker — SMS Car Audio */
(() => {
  function loadScript(a) {
    var b = document.getElementsByTagName("head")[0], c = document.createElement("script");
    c.type = "text/javascript";
    c.src = "https://tracker.metricool.com/resources/be.js";
    c.onreadystatechange = a;
    c.onload = a;
    b.appendChild(c);
  }
  loadScript(function() {
    beTracker.t({hash:"55c826c96ac0f3637c9f666b53137cb4"});
  });
})();
